import React from "react";
import { Box } from "@mui/material";
import GradeReports from "../../components/common/GradeReports/GradeReports";
const GradeReportsGrid = ({
  searchText,
  tableRef,
  apiRef,
  isCheckboxColumn,
  onCompaniesChange,
  isLocationColumn,
  isStatusColumn,
  isLastActivityColumn,
  isGradeColumn,
  isInvestmentCapitalColumn,
  isCashOutDateColumn,
  isActionColumn,
  onSelectedCompanies,
  selectedCompanies, 
  reportName,
  requestId,
  statusType
}) => {
  return (
    <Box
      sx={{
        alignItems: "center",
        bgcolor: "#fff",
        py: 1.5,
      }}
    >
      <GradeReports
        searchText={searchText}
        ref={tableRef}
        apiRef={apiRef}
        isCheckboxColumn={isCheckboxColumn}
        onCompaniesChange={onCompaniesChange}
        isLocationColumn={isLocationColumn}
        isStatusColumn={isStatusColumn}
        isLastActivityColumn={isLastActivityColumn}
        isGradeColumn={isGradeColumn}
        isInvestmentCapitalColumn={isInvestmentCapitalColumn}
        isCashOutDateColumn={isCashOutDateColumn}
        isActionColumn={isActionColumn}
        onSelectedCompanies={onSelectedCompanies}
        selectedCompanies={selectedCompanies}
        requestId={requestId}
      />
    </Box>
  );
};

export default GradeReportsGrid;
